module.exports = __webpack_public_path__ + "static/large-product-finder@3x-20cfb25e8b6b0cec7da026d4a878894c.png";